import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { propBool, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { offerCandidateInterviewDateForView } from '../../../../../../../helpers/rfp';
const OfferOneBottom = (props) => {
    const { isDisabled, onClickSendOff, rfp, viewRequest } = props;
    const { offer: { candidate_interview_date: candidateInterviewDate }, } = viewRequest;
    const showValue = useMemo(() => offerCandidateInterviewDateForView(candidateInterviewDate), [candidateInterviewDate]);
    return (_jsxs("div", Object.assign({ className: 'rfp_one_offer_detail_container_bottom' }, { children: [candidateInterviewDate && (_jsxs("div", Object.assign({ className: 'interview_row' }, { children: [_jsx("div", Object.assign({ className: 'label_value' }, { children: "\u9762\u8AC7\u5E0C\u671B\u65E5\uFF1A" })), _jsx("div", Object.assign({ className: 'text_value' }, { children: showValue }))] }))), _jsxs("div", Object.assign({ className: 'action_box' }, { children: [_jsx("button", Object.assign({ className: 'button send_off', disabled: isDisabled, onClick: onClickSendOff, type: 'button' }, { children: "\u9762\u8AC7\u3092\u898B\u9001\u308B" })), _jsx(Link, Object.assign({ className: clsx('button', 'service', 'interview', {
                            disabled: isDisabled,
                            event_none: isDisabled,
                        }), to: `/project/client/${rfp.id}/interview/input?id=${viewRequest.id}` }, { children: "\u9762\u8AC7\u65E5\u7A0B\u3092\u6C7A\u3081\u308B" }))] }))] })));
};
OfferOneBottom.propTypes = {
    isDisabled: propBool().isRequired,
    onClickSendOff: propFunc().isRequired,
    rfp: propShape().isRequired,
    viewRequest: propShape().isRequired,
};
export default OfferOneBottom;
